import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { ASSETS } from "@/lib/services";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(form.email, form.password);
      navigate("/admin", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink-800 text-bone-50 flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-12 justify-center">
          <img src={ASSETS.logo} alt="VF" className="h-14 w-14 object-contain" />
          <div className="text-left">
            <div className="font-serif text-xl tracking-wide">Vasileios Filippidis</div>
            <div className="uppercase tracking-[0.28em] text-[10px] text-gold-500">Control Panel</div>
          </div>
        </div>

        <form onSubmit={onSubmit} className="bg-ink-700 border border-ink-600 p-10 space-y-6" data-testid="admin-login-form">
          <div>
            <div className="eyebrow !text-gold-400 mb-6">Sign in</div>
            <h1 className="font-serif text-3xl">Welcome back</h1>
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.22em] text-bone-100/60 mb-2">Email</label>
            <input
              required
              type="email"
              className="input-dark"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              data-testid="admin-login-email"
              autoFocus
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-[0.22em] text-bone-100/60 mb-2">Password</label>
            <input
              required
              type="password"
              className="input-dark"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              data-testid="admin-login-password"
            />
          </div>

          {error && (
            <div className="text-sm text-red-300 bg-red-900/30 border border-red-700/50 p-3" data-testid="admin-login-error">
              {error}
            </div>
          )}

          <button type="submit" disabled={submitting} className="btn-gold w-full disabled:opacity-60" data-testid="admin-login-submit">
            {submitting ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="text-center mt-8 text-xs uppercase tracking-[0.24em] text-bone-100/40">
          Authorized personnel only
        </p>
      </div>
    </div>
  );
}
